import { createPrefetchableAsyncPaginatedDataContext, pageDataErrorHandler } from 'src/app/shared/contexts/asyncData';

import { getFirstPageData, getNextPageData } from './api';

export const {
	Context: StarterDashboardCommentsPagePaginatedDataContext,
	Provider: StarterDashboardCommentsPagePaginatedDataContextProvider,
	useContext: useStarterDashboardCommentsPagePaginatedData,
	useAsyncData: useStarterDashboardCommentsPaginatedDataFromApi,
	prefetchAsyncData: prefetchStarterDashboardCommentsPaginatedDataFromApi,
} = createPrefetchableAsyncPaginatedDataContext({
	name: 'StarterDashboardCommentsPagePaginatedDataContext',
	dataProperty: 'pagePaginatedData',
	getFirstPageData,
	getNextPageData,
	getUniqueId: (slug) => slug,
	errorHandler: pageDataErrorHandler(),
});
